import Subscribe from "../modules/subscribe";

const ProjectsOverview = {
  init() {
    Subscribe.init();

  },
};

export default ProjectsOverview;
